/// <reference types="alm-coreutil.js" />
/// <reference types="alm-animframe.js" />
/// <reference types="alm-tasker.js" />

import { Application } from './job/Application';

const app = new Application();
